/**
Functionality: 登入Application
Author: Neil
Date: 2019/12/04

*/
<template>
  <div class="layout">
    <the-background></the-background>
    <div class="content">
      <router-view></router-view>
      <the-footer></the-footer>
    </div>
  </div>
</template>

<script>
import TheBackground from "@/components/TheBackground";
import TheFooter from "@/components/TheFooter";
export default {
  name: "app",
  components: {
    TheBackground,
    TheFooter,
  }, // End of component
}; // End of export
</script>

<style>
body {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  font-family: Helvetica, Arial, "LiHei Pro", "Microsoft JhengHei", "PMingLiU",
    sans-serif !important;
  font-size: 1rem;
  position: relative;
}
.content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
